'use client';

import { X } from 'lucide-react';
import React, { useRef } from 'react';
import type { SubjectAttributes } from '../../utilities/change-requests/subject-marks';
import { TrackedPhoneLink } from '../shared/tracked-phone-link';
import { trackPlausibleEvent } from '../../utilities/track-plausible-event';

const BuyNowButton: React.FC<{
  className?: string;
  children?: React.ReactNode;
  phone?: string;
  /** The Subject attribute naming where the phone number is read from, from the server caller. */
  phoneSubject?: SubjectAttributes;
}> = ({
  className,
  children,
  phone,
  phoneSubject,
}) => {
    const dialogRef = useRef<HTMLDialogElement>(null);

    const openDialog = () => {
      dialogRef.current?.showModal();
      trackPlausibleEvent('BuyProductClick');
    };

    return (
      <>
        <button type="button" className={className} onClick={openDialog}>
          {children}
        </button>

        <dialog ref={dialogRef} className="modal bg-base-content/50 backdrop-blur-xs">
          {/* The dialog's only content that is not fixed copy is the phone number. */}
          <div {...phoneSubject} className="modal-box">
            <form method="dialog">
              <button className="btn btn-sm btn-ghost absolute right-2 top-2 btn-square">
                <X />
                <span className="sr-only">Close</span>
              </button>
            </form>

            <h2 className="font-bold text-lg">
              Product Unavailable Online
            </h2>

            {phone ? (
              <>
                <p className="py-4">
                  Please call to purchase this product.
                </p>

                <TrackedPhoneLink phone={phone} className="btn btn-primary btn-lg w-full" isConversion>
                  Call {phone}
                </TrackedPhoneLink>
              </>
            ) : (
              <p className="py-4">
                This product is unavailable to purchase online.
              </p>
            )}
          </div>
        </dialog>
      </>
    );
  };

export default BuyNowButton;
